/**
 * Italian municipalities (comuni) validation utility.
 * Provides city autocomplete and CAP ↔ City coherence validation.
 */

let comuniData = null;
let comuniPromise = null;

async function loadComuni() {
  if (comuniData) return comuniData;
  if (comuniPromise) return comuniPromise;

  comuniPromise = import("../data/comuni-raw.json")
    .then((mod) => {
      const raw = mod.default || mod;
      comuniData = raw.map((c) => ({
        nome: c.nome,
        cap: c.cap,
        sigla: c.sigla,
      }));
      return comuniData;
    })
    .catch((err) => {
      console.warn("Failed to load comuni data:", err);
      comuniPromise = null;
      return null;
    });

  return comuniPromise;
}

/**
 * Search for city suggestions (autocomplete).
 * Returns max 8 results.
 */
export async function searchCity(query) {
  const data = await loadComuni();
  if (!data || !query || query.length < 2) return [];

  const q = query.toLowerCase().trim();
  const results = [];

  for (let i = 0; i < data.length && results.length < 8; i++) {
    if (data[i].nome.toLowerCase().startsWith(q)) {
      results.push(data[i]);
    }
  }

  return results;
}

/**
 * Validate that a CAP belongs to a given city.
 */
export async function validateCapCity(cap, cityName) {
  const data = await loadComuni();
  if (!data) return { valid: false, validCaps: [], cityFound: false };

  const normalized = cityName.toLowerCase().trim();
  const comune = data.find((c) => c.nome.toLowerCase() === normalized);

  if (!comune) {
    return { valid: false, validCaps: [], cityFound: false };
  }

  const valid = comune.cap.includes(cap);
  return { valid, validCaps: comune.cap, cityFound: true };
}

/**
 * Check if a city name exists.
 */
export async function cityExists(cityName) {
  const data = await loadComuni();
  if (!data || !cityName) return false;
  return data.some((c) => c.nome.toLowerCase() === cityName.toLowerCase().trim());
}
